// extracted by mini-css-extract-plugin
export var sliderRange = "_cg-2";
export var sliderRoot = "_cg-0";
export var sliderThumb = "_cg-3";
export var sliderTrack = "_cg-1";